import {createSelector} from 'reselect'
import {
  selectInfo,
  selectEmailCredentials,
  selectProfileType
} from 'models/user/selectors'

export const selectEditable = (state) => state.profile.editable
export const selectInlineError = (state) => state.profile.inlineError
export const selectSentEmails = (state) => state.profile.sentEmails

export const selectRawContacts = createSelector(
  selectInfo,
  (info) => info && info.contacts
)

export const selectContactEmails = createSelector(
  selectRawContacts,
  (contacts) =>
    contacts
      ? contacts
          .filter(({type}) => type !== 'PHONE')
          .sort((a, b) => {
            if (a.type === b.type) {
              return 0
            }

            return a.type === 'EMAIL' ? -1 : 1
          })
      : []
)

export const selectContactPhones = createSelector(
  selectRawContacts,
  (contacts) => (contacts ? contacts.filter(({type}) => type === 'PHONE') : [])
)

export const selectSuggestTfa = createSelector(
  selectEmailCredentials,
  (emailCredentials) =>
    emailCredentials &&
    emailCredentials.filter(({is2faEnabled}) => !is2faEnabled).length !== 0
)

export const selectSuggestQuestion = createSelector(
  selectProfileType,
  selectInfo,
  (type, info) => type === 'general' && info && !info.question
)

export const selectSuggestPhone = createSelector(
  selectProfileType,
  selectInfo,
  (type, info) => type === 'general' && info && !info.ramblerMailPhone
)
